import { useMemo, useState } from "react";
import { ExternalLink } from "lucide-react";
import { ExploreInteractionType } from "@/v2/entities/explore/Explore.model";
import { ExploreState } from "@/v2/features/explore/ExploreState.model";
import { buildSearchParams } from "@/v2/features/explore/useExploreState";

export interface LinkToExplorePageProps extends ExploreState {
  text: string;
  source: ExploreInteractionType;
}

export function LinkToExplorePage({
  text,
  source,
  ...exploreState
}: LinkToExplorePageProps) {
  const [isHover, setIsHover] = useState(false);

  const url = useMemo(() => {
    const searchParams = buildSearchParams(exploreState);
    return `/explore/${source}?${searchParams.toString()}`;
  }, [exploreState]);

  return (
    <a
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      href={url}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center justify-center whitespace-nowrap text-md font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5 text-primary"
    >
      {text}
      <ExternalLink
        className={`w-4 h-4 ml-1 transition-all duration-200 ${
          isHover ? "opacity-100" : "opacity-0"
        }`}
      />
    </a>
  );
}
